module.exports = __webpack_public_path__ + "img/Publish-My-Website-th.e94e2f9.png";